import { normalize, schema } from 'normalizr';
import { ClientViewModel } from 'stageclip-common';

import { NormalizedClient } from '../../models/normalized/normalizedClient';
import { ById } from '../../store/normalizedState';

import * as EntityNormalizers from './entityNormalizers';
import * as ShopNormalizers from './shopNormalizers';

const { Entity } = schema;

export interface NormalizedClients extends ShopNormalizers.NormalizedShops {
  clients: ById<NormalizedClient>;
  archivedClients: ById<NormalizedClient>;
}

export const clientSchema = new Entity('clients', {
  shop: ShopNormalizers.shopSchema,
});

export function normalizeClient(data: ClientViewModel): EntityNormalizers.NormalizedSingleEntity<NormalizedClients> {
  return normalize(data, clientSchema);
}

export function normalizeClientsArray(
  data: ClientViewModel[],
): EntityNormalizers.NormalizedEntityArray<NormalizedClients> {
  return normalize(data, new schema.Array(clientSchema));
}
